import * as React from 'react';
import { AsidePanel } from '.';
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ConfirmationAsidePanel = props => {
  var _props$headerText;
  return /*#__PURE__*/_jsxs(AsidePanel, {
    isOpen: props.isOpen,
    onCancelClick: props.onCancelClick,
    onConfirmClick: props.onConfirmClick,
    headerText: (_props$headerText = props.headerText) !== null && _props$headerText !== void 0 ? _props$headerText : 'Are you sure?',
    actionButtonName: "Confirm",
    dataId: "confirm-aside",
    isActionButtonDisabled: props.isConfirmButtonDisabled,
    children: [props.subText, props.children]
  });
};